export const EiasJkhMo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.04297 18.853C4.3009 18.6654 4.94338 18.3183 5.44987 18.4309C6.08297 18.5716 8.05262 19.6971 9.1078 20.6116C10.163 21.5261 12.9768 22.7219 15.2278 21.8074C16.7754 20.9285 19.4867 18.5725 19.7299 18.4309C20.1519 18.185 19.3781 16.9536 16.9864 18.0792C16.2595 18.6654 14.4259 19.7674 12.9064 19.4861C11.387 19.2047 10.0223 18.3961 9.88159 17.6571C10.7257 17.4112 12.625 18.3961 14.1023 18.853C14.8057 18.9588 16.1563 18.6701 16.2126 17.6571C15.4388 17.493 13.6099 16.9537 12.4843 16.1095C11.0775 15.0543 9.38918 14.2805 7.7009 14.4916C6.01262 14.7026 4.04297 16.3205 4.04297 18.853Z"
      fill="#1677D2"
    />
    <path
      d="M5.30918 15.0195L6.64573 14.3161V5.24157L5.30918 6.43744V15.0195Z"
      fill="#878787"
    />
    <path
      d="M7.48987 13.9643H8.82642V3.48295L7.48987 4.81951V13.9643Z"
      fill="#878787"
    />
    <path
      d="M9.52987 13.9643V2.99054L10.7961 1.79468V14.4916L9.52987 13.9643Z"
      fill="#878787"
    />
    <path
      d="M17.3381 6.01537V5.24157L11.0775 1.79468V2.56847L17.3381 6.01537Z"
      fill="#878787"
    />
    <path
      d="M17.3381 7.70364V7.0002L11.0775 3.48295V4.1864L17.3381 7.70364Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 5.73399L14.1023 7.42226L14.7354 7.14089L11.0775 5.03054V5.73399Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 7.14089L12.7657 8.05537L13.3988 7.77399L11.0775 6.43744V7.14089Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 8.96985L11.6402 9.32158V8.54778L11.0775 8.2664V8.96985Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 10.6581L11.6402 11.0099V10.2361L11.0775 9.95468V10.6581Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 12.2057L11.6402 12.5574V11.7836L11.0775 11.5023V12.2057Z"
      fill="#1677D2"
    />
    <path
      d="M11.0775 13.7533L11.6402 14.105V13.3312L11.0775 13.0499V13.7533Z"
      fill="#1677D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6402 13.3312V14.105V14.7381L12.7086 15.3712L13.3285 15.0899V15.7386L15.4388 16.9892V6.85951L14.7354 7.14089L14.1023 7.42226L13.3988 7.77399L12.7657 8.05537L11.6402 8.54778V9.32158V10.2361V11.0099V11.7836V12.5574V13.3312ZM13.3285 9.53261L12.4843 9.95468V9.18089L13.3285 8.75882V9.53261ZM14.665 8.82916L13.8209 9.25123V8.47744L14.665 8.05537V8.82916ZM13.3285 11.2209L12.4843 11.643V10.8692L13.3285 10.4471V11.2209ZM14.665 10.5174L13.8209 10.9395V10.1657L14.665 9.74364V10.5174ZM13.3285 12.7685L12.4843 13.1905V12.4167L13.3285 11.9947V12.7685ZM14.665 12.065L13.8209 12.4871V11.7133L14.665 11.2912V12.065ZM13.3285 14.3161L12.4843 14.7381V13.9643L13.3285 13.5423V14.3161ZM14.665 13.6126L13.8209 14.0347V13.2609L14.665 12.8388V13.6126ZM14.665 15.1602L13.8209 15.5823V14.8085L14.665 14.3864V15.1602Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 8.40709V9.18089L16.283 8.75882V7.98502L17.1271 8.40709Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 9.11054V9.88433L17.5492 9.46226V8.68847L18.3933 9.11054Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 10.7988V11.5726L17.5492 11.1505V10.3767L18.3933 10.7988Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 10.0954V10.8692L16.283 10.4471V9.6733L17.1271 10.0954Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 11.643V12.4167L16.283 11.9947V11.2209L17.1271 11.643Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 12.3464V13.1202L17.5492 12.6981V11.9243L18.3933 12.3464Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 13.1905V13.9643L16.283 13.5423V12.7685L17.1271 13.1905Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 13.894V14.6678L17.5492 14.2457V13.4719L18.3933 13.894Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 15.4416V16.2154L17.5492 15.7933V15.0195L18.3933 15.4416Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 14.7381V15.5119L16.283 15.0899V14.3161L17.1271 14.7381Z"
      fill="#1677D2"
    />
    <path
      d="M17.1271 16.4264V17.2002L16.283 16.7781V16.0043L17.1271 16.4264Z"
      fill="#1677D2"
    />
    <path
      d="M18.3933 17.1299L17.5492 17.4816V16.7078L18.3933 17.1299Z"
      fill="#1677D2"
    />
  </svg>
);
